import { Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-sample-view-content-related',
  templateUrl: './sample-view-content-related.component.html',
  styleUrls: ['./sample-view-content-related.component.scss']
})
export class SampleViewContentRelatedComponent implements OnInit {

  @Input() relatedData: any;
  @Input() oggetto_view: string = '';
  @Input() titleSection: string = '';
  public isLinkEsternal: boolean = false;

  public customOptionsOwl: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    navSpeed: 700,
    autoWidth: false,
    autoHeight: false,
    dots: false,
    nav: true,
    navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>']
  };
  constructor() { }

  ngOnInit(): void {
    this.checkvariableInitComponent();
    this.setCarouselForType();
    if (this.titleSection === '') {
      this.titleSection = 'CONTENT_TYPES.TITLE_RELATED_GENERAL';
    }
  }

  private setCarouselForType(): void {
    switch (this.oggetto_view) {
      case 'news':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 2
            },
            900: {
              items: 3
            }
          }
        }
        break;
      case 'eventi':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            800: {
              items: 2
            }
          }
        }
        break;
      case 'avvisi':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 2
            },
            800: {
              items: 3
            }
          }
        }
        break;
      case 'pagine':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            800: {
              items: 4
            }
          }
        }
        break;
      case 'faq-procedure':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          margin: 20,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            1000: {
              items: 4
            }
          }
        }
        break;
      case 'docenti':
        this.customOptionsOwl = {
          ...this.customOptionsOwl,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items: 3
            },
            800: {
              items: 4
            }
          }
        }
        break;
      default:
        break;
    }
  }

  private checkvariableInitComponent() {
    // if (this.blocks.link) {
    //   this.isLinkEsternal = this.nodeService.verifyLinkExternal(this.blocks.link.url);
    // }
    // if (this.blocks.titolo) {
    //   this.titlePage = this.blocks.titolo;
    // }
  }

}
